// import store from '@store';

const paymentMethodMap = {
  Credit: '信用卡付款',
  Vacc: 'ATM虛擬帳戶',
  Free: '免費',
  Prepaid: '包套方案抵扣',
  Cash: '到店付款（現金）',
  Linepay: 'LINE Pay',
  StoreCredit: '現場刷卡',
  Atm: '線下匯款',
  Deposit: '儲值金付款',
};

const paymentMethodIconMap = {
  Credit: 'fontello fontello-card',
  Vacc: 'fontello fontello-atm',
  Free: 'fontello fontello-pet',
  Prepaid: 'fontello fontello-plan',
  Cash: 'fontello fontello-payment-at-shop',
  Linepay: 'fontello fontello-line',
  StoreCredit: 'fontello fontello-shopping-cart',
  Atm: 'fontello fontello-payment-off-line',
  Deposit: 'fal fa-usd-circle',
};

export default function formatPaymentMethod(paymentMethod) {
  return paymentMethodMap[paymentMethod] || '不指定'
}

export function formatPaymentMethodIcon(paymentMethod) {
  return paymentMethodIconMap[paymentMethod] || 'fontello fontello-card'
}
